"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionProvider = void 0;
class CollectionProvider {
    static isCollectionProvider(c) {
        return typeof c.getCollections === 'function';
    }
    static getCollections(c) {
        const collections = [];
        c.forEachField(field => {
            if (!CollectionProvider.isCollectionProvider(field)) {
                return;
            }
            const fieldCaptures = field.getCollections() || [];
            for (const fieldCapture of fieldCaptures) {
                collections.push(fieldCapture);
            }
        });
        return collections;
    }
    static getCollectionIds(c) {
        const collections = [];
        c.forEachField(field => {
            if (!CollectionProvider.isCollectionProvider(field)) {
                return;
            }
            const fieldCaptures = field.getCollectionIds() || [];
            for (const fieldCapture of fieldCaptures) {
                collections.push(fieldCapture);
            }
        });
        return collections;
    }
}
exports.CollectionProvider = CollectionProvider;
//# sourceMappingURL=collection.provider.js.map